module.exports = __webpack_public_path__ + "img/logo3.566fc569.jpg";